import { render, staticRenderFns } from "./DiscountListItem.vue?vue&type=template&id=07c0d8ec"
import script from "./DiscountListItem.vue?vue&type=script&lang=js"
export * from "./DiscountListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports